const transUtcToKst = ({ time }: { time?: string | Date } = {}) => {
  const now = time ? new Date(time) : new Date(); // 서버 시간 기준 현재 로컬 시간
  const GMTNow = now.getTime() + now.getTimezoneOffset() * 60 * 1000; // GMT 현재 시간
  const KoreaTimeDiff = 9 * 60 * 60 * 1000; // 한국 시간은 GMT 시간보다 9시간 앞서 있다.
  const KoreaNow = new Date(GMTNow + KoreaTimeDiff); // GMT 기준 한국 시간을 최종적으로 만들어 준다.
  return KoreaNow;
};

export default transUtcToKst;
